export const users = [
  {
    email: "ranokraihan@gmail.com",
    password: "123456",
    name: "Ranok Raihan",
  },
  {
    email: "cristopher@gmail.com",
    password: "123456",
    name: "Cristopher",
  },
  {
    email: "robert@gmail.com",
    password: "123456",
    name: "Robert",
  },
  {
    email: "james@gmail.com",
    password: "123456",
    name: "James",
  },
  {
    email: "morgan@gmail.com",
    password: "123456",
    name: "Morgan",
  },
  {
    email: "tomholand@gmail.com",
    password: "123456",
    name: "Tom Holand",
  },
  {
    email: "bolton@gmail.com",
    password: "123456",
    name: "Bolton",
  },
  {
    email: "stark@gmail.com",
    password: "123456",
    name: "Stark",
  },
  {
    email: "brandon@gmail.com",
    password: "123456",
    name: "Brandon Fatman",
  },
  {
    email: "jofri@gmail.com",
    password: "123456",
    name: "Jofri",
  },
  {
    email: "katlyne@gmail.com",
    password: "123456",
    name: "katlyne",
  },
  {
    email: "monika@gmail.com",
    password: "123456",
    name: "Monika",
  },
  {
    email: "jessica@gmail.com",
    password: "123456",
    name: "Jessica",
  },
  {
    email: "amelia@gmail.com",
    password: "123456",
    name: "Amelia",
  },
  {
    email: "sophia@gmail.com",
    password: "123456",
    name: "Sophia",
  },
];
